import { render, staticRenderFns } from "./pagination-display.component.vue?vue&type=template&id=d981a0e8&scoped=true&"
import script from "./pagination-display.component.vue?vue&type=script&lang=ts&"
export * from "./pagination-display.component.vue?vue&type=script&lang=ts&"
import style0 from "./pagination-display.component.vue?vue&type=style&index=0&id=d981a0e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d981a0e8",
  null
  
)

export default component.exports